import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';

window.Modal = Modal;
window.Collapse = Collapse;
window.Dropdown = Dropdown;
window.Offcanvas = Offcanvas;

import './recaptcha.js';
import './scripts.js';

export default {
  Offcanvas,
  Collapse,
  Dropdown,
  Modal,
};
